// extracted by mini-css-extract-plugin
module.exports = {"accessoriesType":"SupportTitle_accessoriesType__s90Ig"};